import logo from '../logo.svg';
import usercircle from '../user-circle.svg';

import {
  NavLink,
  Outlet,
} from "react-router-dom";

import {
  useState
} from 'react'

import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
  TransitionChild,
} from '@headlessui/react';

import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

import {
  ChevronDownIcon,
} from '@heroicons/react/20/solid';

import { useAuth } from '../hooks/useAuth';

import { NAVIGATION } from './_Shared/navigation';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { logout, user } = useAuth();
  const handleLogout = async () => await logout();
  const userNavigation = [
    { name: 'Cerrar sesión', href: '#', handler: handleLogout }
  ];

  return (
    <>
      <div>
        <Transition show={sidebarOpen}>
          <Dialog className="relative z-50 lg:hidden" onClose={setSidebarOpen}>
            <TransitionChild
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </TransitionChild>

            <div className="fixed inset-0 flex">
              <TransitionChild
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <TransitionChild
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                      </button>
                    </div>
                  </TransitionChild>

                  {/* Sidebar component, swap this element with another sidebar if you like */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                    <div className="flex h-16 shrink-0 items-center">
                      <img
                        className="h-12 w-auto"
                        src={logo}
                        alt="RÖEN"
                      />
                      <span className="text-3xl font-bold ml-4">RÖEN</span>
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul className="-mx-2 space-y-1">
                            {NAVIGATION.filter((item) => item.roles.includes(user.role)).map((item) => (
                              <li key={item.name}>
                                <NavLink
                                  target={item.externalLink ? "_blank" : "_self"}
                                  to={item.href}
                                  className={({ isActive }) =>
                                    classNames(
                                      isActive ? "bg-gray-50 text-indigo-600" : "text-gray-700 hover:text-indigo-600 hover:bg-gray-50",
                                      'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                    )
                                  }
                                >
                                  {({ isActive }) => (
                                    <>
                                      <item.icon
                                        className={
                                          classNames(
                                            isActive ? "text-indigo-600" : "text-gray-400 group-hover:text-indigo-600",
                                            'h-6 w-6 shrink-0'
                                          )
                                        }
                                        aria-hidden="true"
                                      />
                                      <span>{item.name}</span>
                                    </>
                                  )}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                        <li className="mt-auto">
                          <a
                            href="https://api.whatsapp.com/send/?phone=5213334523607&text&type=phone_number&app_absent=0"
                            target="_blank"
                            rel="noreferrer"
                            className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                          >
                            <img
                              className="w-28 shrink-0 text-gray-400 group-hover:text-indigo-600"
                              src="https://static.whatsapp.net/rsrc.php/yZ/r/JvsnINJ2CZv.svg"
                              alt='WhatsApp'
                            />
                          </a>
                        </li>
                        { /*
                          <li className="mt-auto" hidden={user.role !== ROLES.ADMIN}>
                            <NavLink
                              to="/config"
                              className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                            >
                              <Cog6ToothIcon
                                className="h-6 w-6 shrink-0 text-gray-400 group-hover:text-indigo-600"
                                aria-hidden="true"
                              />
                              Configuración
                            </NavLink>
                          </li>
                          */
                        }
                      </ul>
                    </nav>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </Dialog>
        </Transition>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:z-49 lg:flex lg:w-70 lg:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
            <div className="flex h-16 shrink-0 items-center">
              <img
                className="h-12 w-auto"
                src={logo}
                alt="RÖEN"
              />
              <span className="text-3xl font-bold ml-4 text-gray-700">RÖEN</span>
            </div>
            <nav className="flex flex-1 flex-col">
              <ul className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul className="-mx-2 space-y-1">
                    {NAVIGATION.filter((item) => item.roles.includes(user.role)).map((item) => (
                      <li key={item.name}>
                        <NavLink
                          target={item.externalLink ? "_blank" : "_self"}
                          to={item.href}
                          className={({ isActive }) =>
                            classNames(
                              isActive ? "bg-gray-50 text-indigo-600" : "text-gray-700 hover:text-indigo-600 hover:bg-gray-50",
                              'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                            )
                          }
                        >
                          {({ isActive }) => (
                            <>
                              <item.icon
                                className={
                                  classNames(
                                    isActive ? "text-indigo-600" : "text-gray-400 group-hover:text-indigo-600",
                                    'h-6 w-6 shrink-0'
                                  )
                                }
                                aria-hidden="true"
                              />
                              <span>{item.name}</span>
                            </>
                          )}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="mt-auto">
                  <a
                    href="https://api.whatsapp.com/send/?phone=5213334523607&text&type=phone_number&app_absent=0"
                    target="_blank"
                    rel="noreferrer"
                    className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                  >
                    <img
                      className="w-28 shrink-0 text-gray-400"
                      src="https://static.whatsapp.net/rsrc.php/yZ/r/JvsnINJ2CZv.svg"
                      alt='WhatsApp'
                    />
                  </a>
                </li>
                {/*
                  <li className="mt-auto" hidden={user.role !== ROLES.ADMIN}>
                    <NavLink
                      to="/config"
                      className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600"
                    >
                      <Cog6ToothIcon
                        className="h-6 w-6 shrink-0 text-gray-400 group-hover:text-indigo-600"
                        aria-hidden="true"
                      />
                      Configuración
                    </NavLink>
                  </li>
                  */
                }
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-48">
          <div className="sticky top-0 z-39 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden" onClick={() => setSidebarOpen(true)}>
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>

            {/* Separator */}
            <div className="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true" />

            <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
              <div className="relative flex flex-1"></div>
              <div className="flex items-center gap-x-4 lg:gap-x-6">
                {/* Separator */}
                <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" aria-hidden="true" />

                {/* Profile dropdown */}
                <Menu as="div" className="relative">
                  <MenuButton className="-m-1.5 flex items-center p-1.5">
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="h-8 w-8 rounded-full bg-gray-50"
                      src={usercircle}
                      alt="Foto de Perfil"
                    />
                    <span className="hidden lg:flex lg:items-center">
                      <span className="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
                        { user.name }
                      </span>
                      <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </MenuButton>
                  <Transition
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <MenuItems className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                      {userNavigation.map((item) => (
                        <MenuItem key={item.name} onClick={item.handler}>
                          {({ focus }) => (
                            <a
                              href={item.href}
                              className={classNames(
                                focus ? 'bg-gray-50' : '',
                                'block px-3 py-1 text-sm leading-6 text-gray-900'
                              )}
                            >
                              {item.name}
                            </a>
                          )}
                        </MenuItem>
                      ))}
                    </MenuItems>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>

          {user?.expense_taxonomy_url?.includes('expenseTaxonomy.json')
            && user?.income_taxonomy_url?.includes('incomeTaxonomy.json')
            && (
              <div className="flex items-center gap-x-6 bg-indigo-600 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
                <p className="text-sm/6 text-white">
                  <a href="https://api.whatsapp.com/send/?phone=5213334523607&text&type=phone_number&app_absent=0"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="w-28 shrink-0 text-gray-400 group-hover:text-indigo-600 inline"
                      src="https://static.whatsapp.net/rsrc.php/yZ/r/JvsnINJ2CZv.svg"
                      alt='WhatsApp'
                    />
                    <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
                      <circle r={1} cx={1} cy={1} />
                    </svg>
                    Habla con nosotros para personalizar Röen o resolver tus dudas
                  </a>
                </p>
                <div className="flex flex-1 justify-end">
                </div>
              </div>
            )
          }

          <main className="py-10">
            <div className="px-4 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}
